import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="intro">
        <div>
          <h2>HI I'M LUKASZ</h2>
          <h3>(but everyone calls me Solo)</h3>
        </div>
        <p className="App-intro">
          I create things.<br />
          Look around to see what I've done for clients and for fun.
        </p>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/